import type { ReactNode } from 'react'
import { Typography } from '@/components/ui/typography'
import { Separator } from '@/components/ui/separator'

interface PageHeaderProps {
  title: string
  useSeparator?: boolean
  children?: ReactNode
}

const PageHeader = ({
  title,
  useSeparator = true,
  children,
}: PageHeaderProps) => {
  return (
    <div className="flex flex-col gap-3 pr-4 md:pr-8 transition-[opacity,transform] duration-300 ease-out will-change-[opacity,transform]">
      <div className="flex flex-col gap-4 md:flex-row md:items-center md:justify-between">
        <Typography variant="h1">{title}</Typography>
        {children}
      </div>
      {useSeparator && <Separator />}
    </div>
  )
}

export { PageHeader }
